import type { FieldType, SignerProfile } from '../types/fields';

/** Derive up to three uppercase initials from a full name (e.g. "Jane Smith" → "JS"). */
export function deriveInitialsFromName(name: string, fallback = 'JD'): string {
  const source = name.trim() || fallback;
  return source
    .split(' ')
    .filter(Boolean)
    .map((part) => part[0])
    .join('')
    .toUpperCase()
    .slice(0, 3);
}

export function getDefaultValueForType(type: FieldType, profile: SignerProfile): string {
  if (type === 'date') {
    try {
      return new Date().toLocaleDateString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    } catch {
      return new Date().toLocaleDateString();
    }
  }
  if (type === 'name') return profile.name || 'Printed Name';
  if (type === 'initials') return deriveInitialsFromName(profile.name);
  if (type === 'text') return '';
  return '';
}